import { ReactElement, ReactNode, cloneElement } from 'react';
import { WizardStore, WizardElementProps } from './Wizard';

export type WizardContainerProps = {
  open: boolean;
  Wrapper?: ReactElement<{ children?: ReactNode }>;
  children?: ReactNode;
};

export type WizardContainerRenderProps = WizardContainerProps &
  WizardElementProps<WizardStore, string>;

export const WizardContainer = (
  {
    open,
    Wrapper,
    children,
    get,
    set,
    go,
    prev,
    curr,
  }: WizardContainerRenderProps,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  render: (props: any) => ReactElement,
) => {
  const Container = render({ open, children, get, set, go, prev, curr });
  return (
    <>
      {Wrapper
        ? cloneElement(
            Wrapper as ReactElement<
              WizardElementProps<WizardStore, string> & {
                children?: ReactNode;
              }
            >,
            {
              children: Container,
              get,
              set,
              go,
              prev,
              curr,
            },
          )
        : Container}
    </>
  );
};
